import { render, staticRenderFns } from "./loopDetail.vue?vue&type=template&id=f5bd0520&scoped=true&"
import script from "./loopDetail.vue?vue&type=script&lang=js&"
export * from "./loopDetail.vue?vue&type=script&lang=js&"
import style0 from "./loopDetail.vue?vue&type=style&index=0&id=f5bd0520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd0520",
  null
  
)

export default component.exports